export var PrefetchFailureTypes = /*#__PURE__*/ function(PrefetchFailureTypes) {
    // response status 204 on VAM request (freewheel-params)
    PrefetchFailureTypes["VamNoContent"] = "vam-no-content";
    // response status 403 on VAM request (freewheel-params)
    PrefetchFailureTypes["VamUnauthorized"] = "vam-unauthorized";
    // response status 500 on VAM request (freewheel-params)
    PrefetchFailureTypes["VamFailure"] = "vam-failure";
    // response status 500 on Adverts request (ex. Media Tailor)
    PrefetchFailureTypes["AdvertisementsFailure"] = "ads-failure";
    return PrefetchFailureTypes;
}({});
export var PrefetchStatus = /*#__PURE__*/ function(PrefetchStatus) {
    PrefetchStatus["Uninitialised"] = "Uninitialised";
    PrefetchStatus["Active"] = "Active";
    PrefetchStatus["Paused"] = "Paused";
    PrefetchStatus["Finished"] = "Finished";
    PrefetchStatus["Destroyed"] = "Destroyed";
    return PrefetchStatus;
}({});

//# sourceMappingURL=prefetch.enums.js.map